var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "请输入废止原因",
        okText: "确认",
        cancelText: "取消",
        width: "500px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-col": { span: 0 },
            "wrapper-col": { span: 24 },
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { prop: "jieguo" } },
            [
              _c("a-textarea", {
                attrs: { placeholder: "请输入废止原因", autocomplete: "off" },
                model: {
                  value: _vm.form.jieguo,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "jieguo", $$v)
                  },
                  expression: "form.jieguo",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }